import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../lib/pixel';
const PRICE_ORIGINAL = '$89.000';
const PRICE_CURRENT = '$19.990 ARS';
const PRICE_VALUE = 19990;
type CTAButtonProps = {
  label?: string;
  showTrust?: boolean;
  tone?: 'dark' | 'light';
};
export function CTAButton({
  label = '🌿 QUIERO MI PACK AHORA',
  showTrust = true,
  tone = 'dark'
}: CTAButtonProps) {
  const isLight = tone === 'light';
  const primaryText = isLight ? 'text-brand-darker' : 'text-brand-cream-light';
  const secondaryText = isLight ? 'text-brand-darker/65' : 'text-brand-cream/75';
  const oldPrice = isLight ? 'text-brand-darker/45' : 'text-brand-primary/70';
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="mt-10 flex flex-col items-center" data-id="element-104" data-mp="2ysfejdphuknd">
      <div className="mb-4 text-center" data-id="element-105" data-mp="38q3imu8zp4i7">
        <div className="flex flex-wrap items-baseline justify-center gap-x-3 gap-y-1" data-id="element-106" data-mp="199eniouusulh">
          <span className={`${oldPrice} text-base line-through sm:text-lg`} data-id="element-107" data-mp="1da8b1h4dw7du">{PRICE_ORIGINAL}</span>
          <span className="text-2xl font-bold text-brand-accent sm:text-3xl md:text-4xl" data-id="element-108" data-mp="1i9uo9qk7pnmn">{PRICE_CURRENT}</span>
        </div>
        <p className={`${primaryText} mt-1 text-sm sm:text-base`} data-id="element-109" data-mp="1n8xtpc43tvv5">Precio de lanzamiento</p>
        <p className={`${secondaryText} mt-2 text-xs sm:text-sm`} data-id="element-110" data-mp="1s8ahq06pp8zb">📥 Descarga digital inmediata — Accedés en segundos</p>
      </div>

      <a href="https://www.mamasincaos.store/cart/45320272543767:1" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout({
      value: PRICE_VALUE,
      currency: 'ARS',
      contentName: 'S.O.S. Lactancia Pack',
      contentIds: ['45320272543767']
    })} className="inline-flex min-h-[58px] w-[90%] items-center justify-center rounded-2xl bg-brand-accent px-7 py-4 text-lg font-bold text-brand-darker shadow-lg transition-all hover:scale-[1.02] hover:bg-[#f0aea2] sm:w-auto sm:px-10 sm:text-xl md:text-2xl" data-id="element-111" data-mp="1w7t0oqez39zi">
        {label}
      </a>

      {showTrust && <div className={`${secondaryText} mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs sm:text-sm`} data-id="element-112" data-mp="1zzsnwdhnhi6c">
          <span className="flex items-center gap-1.5" data-id="element-113" data-mp="1v6puc5cvi8q5"><ShieldCheckIcon size={14} className="text-brand-gold" data-id="element-114" data-mp="28zfes5cr75l5" /> Garantía 7 días</span>
          <span className="flex items-center gap-1.5" data-id="element-115" data-mp="240mcl92x310a"><LockIcon size={14} className="text-brand-gold" data-id="element-116" data-mp="23zkpu7cjgq2q" /> Pago seguro</span>
          <span className="flex items-center gap-1.5" data-id="element-117" data-mp="2iyeozsd639a9"><CreditCardIcon size={14} className="text-brand-gold" data-id="element-118" data-mp="2ix3mdvvgk7kq" /> Mercado Pago</span>
        </div>}
    </motion.div>;
}